import React from 'react';

import styled from '@emotion/styled';

import { Text, mq, COLORS, ProgressBar } from '@clutter/clean';

import { Spacer } from '@shared/components/helpers/spacer';

import { OrderStateEnum, ThirdPartyTransferStateEnum } from '@portal/schema';

import { AppointmentDetailsOrder } from './full_panel';

const StepsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  ${mq({
    fontSize: ['9px', '10px', '11px'],
  })}
`;

const StepItem = styled.div<{ completed: boolean }>`
  text-align: center;
  color: ${({ completed }) => (completed ? COLORS.tealPrimary : COLORS.hippo)};
  font-weight: ${({ completed }) => (completed ? 'bold' : 'normal')};
  flex: 1;
  padding: 0 2px;
  line-height: 1.2;

  ${mq({
    fontSize: ['8px', '9px', '11px'],
  })}
`;

export const LongDistanceMoveStatusTracker: React.FC<{ order: AppointmentDetailsOrder }> = ({ order }) => {
  const longDistanceMove = order.longDistanceMove;
  if (!longDistanceMove) return null;

  const steps = ['Scheduled', 'Picked Up', 'At Origin Hub', 'In Transit', 'At Final Hub', 'Delivered'];

  const getCurrentStep = (): number => {
    const pickup = longDistanceMove.pickup;
    const transfer = longDistanceMove.transfer;
    const delivery = longDistanceMove.delivery;

    if (delivery.state === OrderStateEnum.Completed) return 6; // Delivered

    if (
      transfer?.state === ThirdPartyTransferStateEnum.Inbounding ||
      transfer?.state === ThirdPartyTransferStateEnum.Completed
    )
      return 5; // At Final Hub

    if (transfer?.state === ThirdPartyTransferStateEnum.Enroute) return 4; // In Transit

    if (
      pickup.state === OrderStateEnum.Palletized ||
      pickup.state === OrderStateEnum.Graded ||
      pickup.state === OrderStateEnum.Completed
    ) {
      return 3; // At Origin Hub
    }

    if (pickup.state === OrderStateEnum.Packed) return 2; // Picked Up

    return 1; // Scheduled
  };

  const currentStep = getCurrentStep();
  const progressPercentage = currentStep / steps.length;

  return (
    <>
      <Text.Title size="large">Move Details</Text.Title>
      <Spacer height="16px" />

      {/* Progress Bar */}
      <ProgressBar percentage={progressPercentage} />
      <Spacer height="16px" />

      {/* Status Steps */}
      <StepsContainer>
        {steps.map((step, index) => (
          <StepItem key={step} completed={index < currentStep}>
            {step}
          </StepItem>
        ))}
      </StepsContainer>
    </>
  );
};
